export let keys = {
    esc: 27,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    space: 32,
    enter: 13,
    tab: 9,
    shift: 16,
}

export function getOptions (value, selectEl, services) {
    let matches = [];
    // Loop through each of the option elements 
    selectEl.querySelectorAll('option').forEach(function(el, index) {
// debugger
    // if the option has a value and the option’s text node matches the user-typed value
        if(el.text.trim().length > 0 && el.text
        .toLowerCase().indexOf(value.toLowerCase()) > -1 || services[index].excerpt
        .toLowerCase().indexOf(value.toLowerCase()) > -1) {
                
            // push an object representation to the matches array
            matches.push({
                id: services[index].id,
                name: el.text,
                excerpt: services[index].excerpt
            }); 
        }
    });
    
    return matches;
}

export function getAllOptions (selectEl, services) {
    let list = [];

    selectEl.querySelectorAll('option').forEach(function(el, index) {
                        
        // push an object representation to the matches array
        list.push({
            id: services[index].id,
            name: el.text,
            excerpt: services[index].excerpt
        }); 
    })
    return list;
}